import { apiClient, ApiName } from './api'

export const fetchCountriesBanks = () => {
  return apiClient.get(ApiName.CONFIGS, 'banks')
}

export const fetchTypeByClientType = (config) => {
  return apiClient.get(ApiName.CONFIGS, 'natures', config)
}

export const fetchNatureType = (config) => {
  return apiClient.get(ApiName.CONFIGS, 'natures', config)
}

export const fetchBanks = () => {
  return apiClient.get(ApiName.BANKS)
}
